export const getDimensions = (dimension: string, dimensionMode: string) => {

    if (dimension) {
        if (dimensionMode) {
            if (dimensionMode === "px") {
                return (`${dimension}px`)
            } else if (dimensionMode === "%") {
                return (`${dimension}%`)
            }
            else if (dimensionMode !== "px" && dimensionMode !== '%') {
                return (dimension)
            }
        }
        return `${dimension}px`
    } else {
        return undefined
    }

};